<template>
    <OverlayLoader :isLoading="!isLoaded">
        <main class="page page-dashboard">
            <div class="container">
                <PageHeader
                    :title="`${this.$translate.text('general.customer_groups')} ( ${connection.name} )`"
                />

                <ConnectionMenu></ConnectionMenu>

                <!--<div v-if="connection.webshop_type === 'woocommerce'">
                    <Alert>{{ t('alert.combine.customergroups.woocommerce') }}</Alert>
                </div>-->

                <WhiteTable
                    @changePage="changePage"
                    :showPaginate="true"
                    :paginate="paginate"
                    :labels="[$translate.text('general.brand'), $translate.text('general.categories'), $translate.text('general.customer_group'), $translate.text('general.discount'), $translate.text('general.field')]"
                >
                    <template slot="table-data">
                        <tr v-for="customerGroup in customerGroups" :key="customerGroup.id">
                            <td v-if="customerGroup.brand" style="width: 25%;">{{ customerGroup.brand }}</td>
                            <td v-else style="width: 25%;">*</td>
                            <td style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden; max-width: 1px; width: 25%;">{{ flattenCategories(customerGroup.categories) }}</td>
                            <td style="width: 25%;">{{ customerGroup.customer_group }}</td>
                            <td v-if="!customerGroup.use_b2b" style="width: 7.5%;">{{ customerGroup.value }}</td>
                            <td v-else style="width: 7.5%;"></td>
                            <td v-if="customerGroup.use_b2b" style="width: 7.5%;">{{ customerGroup.feed_name }}</td>
                            <td v-else style="width: 7.5%;"></td>
                            <td class="align-right" style="width: 10%;">
                                <i class="fal fa-edit" @click="$router.push({ name: 'Clients Connections Customer Groups Edit', params: { id: $route.params.id, customerGroupId: customerGroup.id } })" v-tooltip.bottom="$translate.text('tooltip.edit')"></i>
                                <i class="fal fa-trash-alt" @click="deleteCustomerGroup(customerGroup.id)" v-tooltip.bottom="$translate.text('tooltip.delete')"></i>
                            </td>
                        </tr>
                        <tr v-if="!customerGroups.length">
                            <td colspan="6">{{ t('general.no_results_found') }}</td>
                        </tr>
                    </template>
                </WhiteTable>
            </div>

            <FloatingButton
                @clicked="$router.push({ name: 'Clients Connections Customer Groups Add' })"
            />
        </main>
    </OverlayLoader>
</template>
<script>
import swal from 'sweetalert';
import handleError from '@/helpers/error';
import OverlayLoader from '@/components/OverlayLoader/OverlayLoader';
import PageHeader from '@/components/PageHeader/PageHeader';
import WhiteTable from '@/components/Table/WhiteTable';
import FloatingButton from '@/components/FloatingButton/FloatingButton';
import ConnectionMenu from '@/components/ConnectionMenu/ConnectionMenu';

export default {
    name: 'CustomerGroups',

    components: {
        ConnectionMenu,
        PageHeader,
        OverlayLoader,
        WhiteTable,
        FloatingButton,
    },

    data() {
        return {
            customerGroups: [],

            paginate: {
                current_page: 1,
            },

            connection: {},

            loaded: {
                items: {
                    customerGroups: false,
                    connection: false,
                },
            },
        };
    },

    created() {
        this.getCustomerGroups();
        this.getConnection();
    },

    methods: {
        getCustomerGroups() {
            this.API.clients.connections.customerGroups.index(this.$route.params.id, this.paginate.current_page)
                .then((response) => {
                    this.customerGroups = response.data.data;
                    this.paginate = response.data.meta;
                    this.loaded.items.customerGroups = true;
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        changePage(value) {
            switch (value) {
            case 'next':
                this.paginate.current_page += 1;
                break;
            case 'previous':
                this.paginate.current_page -= 1;
                break;
            default:
                this.paginate.current_page = value;
            }

            this.getCustomerGroups();
        },

        deleteCustomerGroup(id) {
            swal(
                this.$translate.text('alert.confirm.delete'),
                {
                    buttons: {
                        cancel: this.$translate.text('general.no'),
                        confirm: this.$translate.text('general.yes'),
                    },
                },
            ).then((value) => {
                if (value) {
                    this.API.clients.connections.customerGroups.destroy(this.$route.params.id, id)
                        .then(() => {
                            this.getCustomerGroups();
                        })
                        .catch((error) => {
                            handleError({
                                error,
                                message: this.$translate.text('alert.whoops'),
                            });
                        });
                }
            });
        },

        getConnection() {
            this.API.clients.connections.show(this.$route.params.id)
                .then(response => {
                    this.connection = response.data.data;
                    this.loaded.items.connection = true;
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        flattenCategories(categories) {
            if (categories === null) {
                return '*';
            }

            const joins = [];

            categories.forEach(category => {
                joins.push(category.label);
            });

            return joins.join(', ');
        },
    },

    computed: {
        isLoaded() {
            return this.loaded.items.customerGroups && this.loaded.items.connection;
        },
    },
};
</script>

<style scoped>
    .white-table {
        padding-top: 20px;
    }
</style>
